var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStadiumInfo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u5207\u7247") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u89C4\\u8303/\\u5207\\u56FE",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u8861\\u6CF0\\u4FE1\\u4F1A\\u6240\\u89C4\\u83032",
    transform: "translate(-166.000000, -1384.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4",
    transform: "translate(110.000000, 684.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-6",
    transform: "translate(0.000000, 668.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "root.list",
    transform: "translate(56.000000, 32.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L20,0 L20,20 L0,20 L0,0 Z",
    id: "root.list-(Background)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L20,0 L20,20 L0,20 L0,0 Z",
    id: "\\u77E9\\u5F62",
    opacity: 0.0000999999975
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.125,16.25 C18.125,16.9403563 17.5653553,17.5 16.875,17.5 L3.125,17.5 C2.43464403,17.5 1.875,16.9403563 1.875,16.25 L1.875,3.5 C1.875,2.94771525 2.32271525,2.5 2.875,2.5 L17.125,2.5 C17.6772847,2.5 18.125,2.94771525 18.125,3.5 L18.125,16.25 L18.125,16.25 Z M3.125,3.75 L3.125,16.25 L16.875,16.25 L16.875,3.75 L3.125,3.75 Z M5,5.625 L5,6.875 L15,6.875 L15,5.625 L5,5.625 Z M5,8.75 L5,10 L12.5,10 L12.5,8.75 L5,8.75 Z",
    id: "root-list",
    fillOpacity: 0.9,
    fill: "currentColor"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStadiumInfo);
export default __webpack_public_path__ + "static/media/stadium-info.007b1a22dac45c71607b4e89be92bcf8.svg";
export { ForwardRef as ReactComponent };